import React, { useState, useEffect } from "react";
import { Callout, Button, Tooltip } from "@blueprintjs/core";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { Trans } from "react-i18next";

import { authenticatedPostFetch, getBackendRoute } from "../../../utils/AuthenticatedFetch";
import { mefPlate, mefDate } from "../../../utils/mef";
import TagIdTitre from "./IdTitre";


export function ReconciliationALPR(props) {

  let title;
  if (props.entryLicensePlate === null && props.exitLicensePlate === null)
    title = <Trans>no plate detected</Trans>
  else if (props.entryLicensePlate === null && props.exitLicensePlate !== null)
    title = <Trans>no plate detected at entry</Trans>
  else if (props.entryLicensePlate !== null && props.exitLicensePlate === null)
    title = <Trans>no plate detected at exit</Trans>
  else if (props.entryLicensePlate !== props.exitLicensePlate)
    title = <Trans>different plate detected at exit</Trans>

  return (
    <Callout title={title} icon="unknown-vehicle">
      <TagIdTitre idtitre={props.parking} />
      <div className="flexbox-center-large">
        <Callout style={{ width: "49%" }} title={<Trans>entry</Trans>}>
          <ul>
            <li>{mefDate(props.entryDate)}</li>
            <li>{props.entryDevice}</li>
            <li>{props.entryLicensePlate !== null
              ?
              <span className="licenseplate-little" key="imm">
                {mefPlate(props.entryLicensePlate)}
              </span>
              : <Trans>no plate detected</Trans>}
            </li>
          </ul>
          {props.entryImage !== null &&
            <Tooltip
              content={<img alt="alpr detection, context capture" src={props.entryImage.base64} style={{ width: "500px" }} />}
              openOnTargetFocus={false}
            >
              <figure style={{ // used to crop the plate on the image
                width: (props.entryImage.width + 140) + "px",
                height: (props.entryImage.height + 50) + "px",
                overflow: "hidden", /*hide bounds of image */
              }}>
                <img src={props.entryImage.base64} alt="alpr detection, plate cropped"
                  style={{
                    margin: "-" + (props.entryImage.y - 25) + "px 0px 0px -" + (props.entryImage.x - 70) + "px"
                  }}
                />
              </figure>
            </Tooltip>}
        </Callout>
        <Callout style={{ width: "49%" }} title={<Trans>exit</Trans>}>
          <ul>
            <li>{mefDate(props.exitDate)}</li>
            <li>{props.exitDevice}</li>
            <li>
              {props.exitLicensePlate !== null
                ?
                <span className="licenseplate-little" key="imm">
                  {mefPlate(props.exitLicensePlate)}
                </span>
                : <Trans>no plate detected</Trans>}
            </li>
          </ul>
          {props.exitImage !== null &&
            <Tooltip content={<img alt="alpr detection, context capture" src={props.exitImage.base64} style={{
              width: "500px"
            }} />} openOnTargetFocus={false}>
              <figure style={{ // used to crop the plate on the image
                width: (props.exitImage.width + 140) + "px",
                height: (props.exitImage.height + 50) + "px",
                overflow: "hidden", /*hide bounds of image */
              }}>
                <img src={props.exitImage.base64} alt="alpr detection, plate cropped"
                  style={{
                    margin: "-" + (props.exitImage.y - 25) + "px 0px 0px -" + (props.exitImage.x - 70) + "px"
                  }}
                />
              </figure>
            </Tooltip>}
        </Callout>
      </div>
      <div className="flexbox-center-center">
        <Button
          text={<Trans>allow access</Trans>}
          intent="success"
          onClick={() => {
            authenticatedPostFetch("/alpr/reconciliation/solve", {
              parkId: props.carParkId,
              alertId: props.alertId,
              decision: true
            }, (res) => console.log(res));
          }}
        />
        <Button
          text={<Trans>deny access</Trans>}
          intent="danger"
          onClick={() => {
            authenticatedPostFetch("/alpr/reconciliation/solve", {
              parkId: props.carParkId,
              alertId: props.alertId,
              decision: false
            }, (res) => console.log(res));
          }}
        />
      </div>
    </Callout>
  );
}

export function ReconciliationsALPR(props) {

  const [reconciliations, setReconciliations] = useState([]);

  function onNewReco(message) {
    try {
      const data = JSON.parse(message.data);
      setReconciliations([...reconciliations, ...data]);
    } catch (e) {
      console.error(e);

      if (message.isTrusted === undefined)
        console.error("Error while parsing reconciliation" + JSON.stringify(message));
    }
  };

  useEffect(() => {
    const client = new W3CWebSocket(getBackendRoute("WS") + "/supervision/alpr/reconciliations", ["Bearer", localStorage.getItem('token')]);
    client.onmessage = onNewReco;
    return () => {
      if (client !== undefined)
        client.close();
    }
  }, []);

  const recos = [];
  for (const reco of reconciliations)
    recos.push(<ReconciliationALPR key={reco.alertId} {...reco} />)

  return (
    <Callout title={<Trans>Réconciliations en sortie</Trans>}>
      {recos}
    </Callout>
  )

}
